const news_pt = require('./news.json')
export default news_pt